module.exports = __webpack_public_path__ + "static/media/lattice_placement_histogram.0b87de9d.png";